import { useEffect, useState } from 'react'
import { qh } from './qh.js'

/* THE TOOLTIP OVER A DOTTED WORD. The kit marks the term and says when the
   pointer is on one; what the card SAYS is the app's, because only the app
   knows whose sense it is — and the moment definitions are shared, whose it is
   becomes the most important line on it.
   It fades, and it waits a beat before it does: a tooltip that fires the
   instant the pointer crosses a word flickers all the way down a paragraph. */
export default function TermTip({ at, word, onOpen, onHold, onRelease }) {
  const [shown, setShown] = useState(false)
  useEffect(() => {
    if (!at || !word) { setShown(false); return undefined }
    const t = setTimeout(() => setShown(true), 180)
    return () => clearTimeout(t)
  }, [at, word])

  if (!at || !word) return null
  // the card is placed under the word, and pulled back inside the window when
  // the word sits near the right edge
  const w = 340
  const left = Math.max(12, Math.min(at.left, window.innerWidth - w - 12))
  const below = window.innerHeight - at.bottom > 200

  return <div className={`dt-tip${shown ? ' is-shown' : ''}`} role="tooltip"
    style={below ? { left, top: at.bottom + 8 } : { left, bottom: window.innerHeight - at.top + 8 }}
    /* the pointer may travel onto the card and stay: entering holds it open,
       leaving lets it go (WordSheet owns the grace) */
    onMouseEnter={e => { e.stopPropagation(); onHold?.() }}
    onMouseLeave={() => onRelease?.()}
    {...qh('A defined word', 'The dotted rule marks a word you have already committed. This card is its definition. Click the word to go to its page.')}>
    <button type="button" className="dt-tip__name" onClick={() => onOpen(word.slug)}
      {...qh(word.name, 'Open this word’s page.')}>{word.name}</button>
    {/* the word and what it means, nothing else (owner call 2026-09-19: "rip
        out the footer — just want the clean definition") */}
    {/* a synonym with no words of its own reads its source's, and says so */}
    {word.via && <span className="dt-tip__via">via {word.via}</span>}
    <p className="dt-tip__body">{word.text || 'Not defined yet.'}</p>
  </div>
}
